import { NgModule, isDevMode } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {

    initialNavigation: 'enabledNonBlocking',
    //enableTracing: isDevMode()
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
